import React from 'react';

export const OperationalFramework = ({ t }) => {
  return (
    <section id="services" className="section-padding section-grey border-t border-gray-300 relative">
      {/* Network diagram overlay */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          {/* Cross axis */}
          <line x1="50%" y1="0" x2="50%" y2="100%" stroke="#000" strokeWidth="2" />
          <line x1="0" y1="50%" x2="100%" y2="50%" stroke="#000" strokeWidth="2" />
          
          {/* Quadrant circles */}
          <circle cx="25%" cy="25%" r="4" fill="none" stroke="#000" strokeWidth="2" />
          <circle cx="75%" cy="25%" r="4" fill="none" stroke="#000" strokeWidth="2" />
          <circle cx="25%" cy="75%" r="4" fill="none" stroke="#000" strokeWidth="2" />
          <circle cx="75%" cy="75%" r="4" fill="none" stroke="#000" strokeWidth="2" />
        </svg>
      </div>

      <div className="container mx-auto px-8 max-w-7xl relative z-10">
        {/* Header */}
        <div className="mb-24">
          <div className="border-l-2 border-gray-900 pl-6 mb-8">
            <p className="text-xs text-gray-600 uppercase tracking-[0.3em] font-medium">{t.framework.label}</p>
          </div>
          <h2 className="text-6xl md:text-8xl font-normal text-gray-900 mb-12 leading-tight tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {t.framework.title1}<br />{t.framework.title2}
          </h2>
        </div>

        {/* Grid system */}
        <div className="grid md:grid-cols-2 gap-px bg-gray-300 border-2 border-gray-300">
          {t.framework.vectors.map((vector, index) => (
            <div 
              key={index}
              className="bg-white p-12 relative group hover:bg-gray-50 transition-colors"
            >
              {/* Corner marker */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-gray-300 group-hover:border-gray-900 transition-colors" />
              
              {/* Vector number */}
              <div className="text-5xl font-light text-gray-200 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                0{index + 1}
              </div>
              
              <h3 className="text-2xl font-normal text-gray-900 mb-6 leading-tight tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {vector.title}
              </h3>
              <p className="text-gray-600 font-light leading-relaxed">
                {vector.description}
              </p>

              {/* Position indicator */}
              <div className="absolute bottom-4 right-4 w-2 h-2 border border-gray-400 rotate-45" />
            </div>
          ))}
        </div>

        {/* System note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500 font-light">
            {t.framework.note}
          </p>
        </div>
      </div>
    </section>
  );
};
